(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["envy-cart-drawer"]) return;
  try {
    
if (!customElements.get('envy-cart-drawer')) {
class EnvyCartDrawer extends HTMLElement {
 connectedCallback(){
  this.dialog=this.querySelector('dialog');this.busy=false;
  this.root=window.Shopify?.routes?.root||'/';
  this.returnKey='envy-checkout-return-'+this.dataset.sectionId;
  this.onPageShow=this.restoreCheckoutReturn.bind(this);
  window.addEventListener('pageshow',this.onPageShow);
  this.onCartClick=this.handleCartLink.bind(this);
  this.onAdd=()=>this.open();
  document.addEventListener('click',this.onCartClick,true);
  document.addEventListener('ARMADA:CART:ADD',this.onAdd);
  this.addEventListener('click',e=>{
   const close=e.target.closest('[data-ecd-close]');if(close)this.close();
   const button=e.target.closest('[data-ecd-quantity]');
   if(button&&!this.busy)this.change(button);
  });
  this.addEventListener('submit',async e=>{
   if(e.target.matches('.ecd-checkout-form')){
    e.preventDefault();
    if(this.busy)return;
    try{await this.refresh();}catch(error){this.error(error.message);return;}
    try{sessionStorage.setItem(this.returnKey,JSON.stringify({url:location.href,at:Date.now()}));}catch(error){}
    location.assign(this.root+'checkout');
    return;
   }
   const discountForm=e.target.closest('[data-ecd-code]');
   if(discountForm){e.preventDefault();if(!this.busy)await this.applyCode(discountForm);return;}
   const form=e.target.closest('[data-ecd-add]');
   if(form){e.preventDefault();if(!this.busy)this.add(form);}
  });
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}});
  this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.close();});
  this.dialog.addEventListener('close',()=>this.unlock());
  this.restoreCheckoutReturn();
 }
 disconnectedCallback(){window.removeEventListener('pageshow',this.onPageShow);document.removeEventListener('click',this.onCartClick,true);document.removeEventListener('ARMADA:CART:ADD',this.onAdd);this.unlock();}
 restoreCheckoutReturn(){
  let saved;
  try{saved=JSON.parse(sessionStorage.getItem(this.returnKey)||'null');}catch(error){return;}
  if(!saved||Date.now()-saved.at>7200000)return;
  let target;
  try{target=new URL(saved.url,location.origin);}catch(error){return;}
  if(target.origin!==location.origin)return;
  const cartPath=this.root.replace(/\/$/,'')+'/cart';
  if(location.pathname.replace(/\/$/,'')===cartPath){
   if(target.pathname.replace(/\/$/,'')===cartPath)target=new URL(this.root,location.origin);
   location.replace(target.href);return;
  }
  if(location.pathname===target.pathname){
   try{sessionStorage.removeItem(this.returnKey);}catch(error){}
   this.open();
  }
 }
 handleCartLink(e){
  const link=e.target.closest('a[href]');if(!link||link.hasAttribute('data-ecd-full-cart')||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const url=new URL(link.href,location.origin);
  if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===this.root.replace(/\/$/,'')+'/cart'){
   e.preventDefault();e.stopImmediatePropagation();this.open();
  }
 }
 lock(){
  this.scrollY=window.scrollY;this.previousBody={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};
  document.body.style.position='fixed';document.body.style.top='-'+this.scrollY+'px';document.body.style.width='100%';document.body.style.overflow='hidden';
 }
 unlock(){if(!this.previousBody)return;Object.assign(document.body.style,this.previousBody);this.previousBody=null;window.scrollTo({top:this.scrollY,behavior:'instant'});}
 async open(){
  if(!this.dialog.open){
   const menu=document.querySelector('header-main [data-armada-selector="navigation-toggle"][aria-expanded="true"]');if(menu)menu.click();
   this.returnFocus=document.activeElement;this.lock();this.dialog.showModal();
  }
  try{await this.refresh();}catch(e){this.error(e.message);}
 }
 close(){this.dialog.close();this.returnFocus?.focus({preventScroll:true});}
 async syncGift(){
  if(this.giftSync)return this.giftSync;
  this.giftSync=this.reconcileGift();
  try{return await this.giftSync;}finally{this.giftSync=null;}
 }
 async reconcileGift(){
  const variant=Number(this.dataset.giftVariant),threshold=Number(this.dataset.giftThreshold);
  const response=await fetch(this.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
  if(!response.ok)throw Error('Unable to check your free gift. Please try again.');
  const cart=await response.json(),gifts=cart.items.filter(item=>item.variant_id===variant);
  const qualified=threshold>0&&cart.currency===this.dataset.storeCurrency&&cart.total_price>=threshold;
  const post=async(path,data)=>{
   const result=await fetch(this.root+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
   const body=await result.json();if(!result.ok)throw Error(body.description||body.message||'Unable to update your free gift.');
  };
  if(qualified&&!gifts.length)await post('cart/add.js',{items:[{id:variant,quantity:1}]});
  for(let i=0;i<gifts.length;i++){
   const quantity=qualified&&i===0?1:0;
   if(gifts[i].quantity!==quantity)await post('cart/change.js',{id:gifts[i].key,quantity});
  }
 }
 async refresh(){
  await this.syncGift();
  const response=await fetch(this.root+'?section_id='+encodeURIComponent(this.dataset.sectionId),{credentials:'same-origin',cache:'no-store'});
  if(!response.ok)throw Error('Unable to load your bag. Please try again.');
  const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-ecd-content]');
  if(!fresh)throw Error('Unable to load your bag. Please try again.');
  const old=this.querySelector('[data-ecd-content]'),focused=document.activeElement;
  const hadFocus=old.contains(focused);old.replaceWith(fresh);
  const count=Number(fresh.dataset.count);
  document.dispatchEvent(new CustomEvent('ARMADA:CART:COUNT:CHANGE',{detail:{count}}));
  if(hadFocus&&this.dialog.open)this.querySelector('[data-ecd-close]')?.focus({preventScroll:true});
 }
 error(message){const el=this.querySelector('[data-ecd-error]');el.textContent=message;el.hidden=false;}
 async applyCode(form){
  const code=String(new FormData(form).get('discount')||'').trim();if(!code)return;
  this.busy=true;this.querySelector('[data-ecd-content]').setAttribute('aria-busy','true');
  let message='',failed=false;
  try{
   const existingResponse=await fetch(this.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
   if(!existingResponse.ok)throw Error('Unable to check your discount. Please try again.');
   const existing=await existingResponse.json();
   const codes=[...new Set([...(existing.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code),code])];
   const response=await fetch(this.root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
   const cart=await response.json();if(!response.ok)throw Error(cart.description||cart.message||'Unable to apply this discount.');
   const entered=cart.discount_codes?.find(d=>d.code.toLowerCase()===code.toLowerCase());
   const applied=entered?.applicable===true||cart.cart_level_discount_applications?.some(d=>d.type==='discount_code'&&d.title.toLowerCase()===code.toLowerCase())||cart.items?.some(item=>item.line_level_discount_allocations?.some(d=>d.discount_application.type==='discount_code'&&d.discount_application.title.toLowerCase()===code.toLowerCase()));
   failed=!applied;message=applied?'Discount applied.':'This code isn’t valid for the items in your bag.';
   await this.refresh();
  }catch(error){failed=true;message=error.message;}
  finally{
   this.busy=false;this.querySelector('[data-ecd-content]').removeAttribute('aria-busy');
   const status=this.querySelector('[data-ecd-code-message]');status.textContent=message;status.dataset.error=String(failed);status.hidden=false;
  }
 }
 async request(path,data){
  this.busy=true;this.querySelector('[data-ecd-content]').setAttribute('aria-busy','true');this.querySelector('[data-ecd-error]').hidden=true;
  try{
   const response=await fetch(this.root+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
   const result=await response.json();if(!response.ok)throw Error(result.description||result.message||'Unable to update your bag.');
   await this.refresh();
  }catch(e){this.error(e.message);}
  finally{this.busy=false;this.querySelector('[data-ecd-content]').removeAttribute('aria-busy');}
 }
 change(button){return this.request('cart/change.js',{id:button.closest('[data-key]').dataset.key,quantity:Number(button.dataset.ecdQuantity)});}
 add(form){return this.request('cart/add.js',{items:[{id:Number(new FormData(form).get('id')),quantity:1}]});}
}
customElements.define('envy-cart-drawer',EnvyCartDrawer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["envy-microlink-technology"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('retention-slider'))customElements.define('retention-slider',class extends HTMLElement{
connectedCallback(){this.track=this.querySelector('.retention-track');this.slides=[...this.track.children];this.index=0;this.paused=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;this.abort=new AbortController();let opts={signal:this.abort.signal};this.controls=this.querySelector('.retention-controls');this.controls.hidden=this.slides.length<2;this.update=()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.querySelector('[data-count]').textContent=(this.index+1)+' / '+this.slides.length;};this.go=(n)=>{this.track.scrollTo({left:((n+this.slides.length)%this.slides.length)*this.track.clientWidth,behavior:this.reduced?'instant':'smooth'});};this.querySelector('[data-prev]').addEventListener('click',()=>this.go(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1),opts);this.querySelector('[data-pause]').addEventListener('click',e=>{this.paused=!this.paused;e.currentTarget.textContent=this.paused?'▶':'Ⅱ';e.currentTarget.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');},opts);this.track.addEventListener('scroll',this.update,opts);this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}},opts);document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.go(i);}},opts);this.update();this.timer=setInterval(()=>{if(this.slides.length>1&&!this.paused&&!this.reduced&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.go(this.index+1);},Number(this.dataset.interval)||4500);}
disconnectedCallback(){clearInterval(this.timer);this.abort.abort();}
});

if(!customElements.get('envy-retention-marquee'))customElements.define('envy-retention-marquee',class extends HTMLElement{
connectedCallback(){
this.viewport=this.querySelector('.erm-viewport');this.track=this.querySelector('.erm-track');this.group=this.querySelector('.erm-group');this.position=0;this.held=false;this.resumeAt=0;this.last=0;this.ready=false;this.keyboardPaused=false;this.abort=new AbortController();const opts={signal:this.abort.signal};this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
this.track.style.setProperty('transform','none','important');
this.width=()=>this.group.getBoundingClientRect().width;
this.normalize=()=>{const w=this.width();if(w<=0)return;if(this.position<w*.5)this.position+=w;else if(this.position>w*1.5)this.position-=w;this.viewport.scrollLeft=this.position;};
const begin=e=>{if(e.button!==undefined&&e.button!==0)return;this.held=true;this.position=this.viewport.scrollLeft;this.previousX=e.clientX;this.mouse=e.pointerType==='mouse';if(this.mouse)this.viewport.setPointerCapture(e.pointerId);};
this.viewport.addEventListener('pointerdown',begin,opts);
this.viewport.addEventListener('pointermove',e=>{if(this.held&&this.mouse){this.viewport.scrollLeft-=e.clientX-this.previousX;this.position=this.viewport.scrollLeft;this.previousX=e.clientX;}},opts);
const release=()=>{if(!this.held)return;this.held=false;this.mouse=false;this.position=this.viewport.scrollLeft;this.resumeAt=performance.now()+900;};
window.addEventListener('pointerup',release,opts);
window.addEventListener('pointercancel',()=>{if(this.mouse)release();},opts);
this.viewport.addEventListener('touchstart',()=>{this.held=true;}, {...opts,passive:true});
this.viewport.addEventListener('touchend',release,{...opts,passive:true});
this.viewport.addEventListener('touchcancel',release,{...opts,passive:true});
this.viewport.addEventListener('scroll',()=>{if(this.held||performance.now()<this.resumeAt){this.position=this.viewport.scrollLeft;if(!this.held)this.resumeAt=performance.now()+180;}},{...opts,passive:true});
this.viewport.addEventListener('dragstart',e=>e.preventDefault(),opts);
this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.viewport.scrollLeft+=(e.key==='ArrowRight'?1:-1)*this.viewport.clientWidth*.65;this.position=this.viewport.scrollLeft;this.resumeAt=performance.now()+1400;}else if(e.code==='Space'){e.preventDefault();this.keyboardPaused=!this.keyboardPaused;}},opts);
this.tick=t=>{const dt=this.last?Math.min(t-this.last,50):0;this.last=t;const w=this.width();if(!this.ready&&w>0){this.position=w;this.viewport.scrollLeft=w;this.ready=true;}if(this.ready&&!this.held&&t>=this.resumeAt&&!this.keyboardPaused&&!document.hidden){if(!this.reduced.matches)this.position+=w*dt/48000;this.normalize();}this.frame=requestAnimationFrame(this.tick);};
Promise.all([...this.querySelectorAll('img')].map(img=>img.decode?img.decode().catch(()=>{}):Promise.resolve())).then(()=>{if(this.isConnected)this.frame=requestAnimationFrame(this.tick);});
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["envy-tester-studies"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('envy-tester-studies')){
class EnvyTesterStudies extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const track=this.querySelector('[data-ets-track]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bind=(rail,prev,next,count)=>{
   if(!rail)return;
   const slides=Array.from(rail.children),move=delta=>{
    const index=Math.round(rail.scrollLeft/(rail.clientWidth+(parseFloat(getComputedStyle(rail).gap)||0)));
    const target=slides[Math.max(0,Math.min(slides.length-1,index+delta))];
    if(target)rail.scrollTo({left:target.offsetLeft-slides[0].offsetLeft,behavior:reduced?'auto':'smooth'});
   };
   prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
   const update=()=>{
    const index=Math.max(0,Math.min(slides.length-1,Math.round(rail.scrollLeft/(rail.clientWidth+(parseFloat(getComputedStyle(rail).gap)||0)))));
    if(prev)prev.disabled=index===0;if(next)next.disabled=index===slides.length-1;
    if(count)count.textContent=(index+1)+' / '+slides.length;
   };
   rail.addEventListener('scroll',update,{passive:true});update();
  };
  bind(track,this.querySelector('[data-ets-prev]'),this.querySelector('[data-ets-next]'),this.querySelector('[data-ets-count]'));
  this.querySelectorAll('.ets-card').forEach(card=>bind(card.querySelector('[data-ets-photos]'),card.querySelector('[data-ets-photo-prev]'),card.querySelector('[data-ets-photo-next]'),card.querySelector('[data-ets-photo-count]')));
  this.addEventListener('shopify:block:select',event=>{
   const card=event.target.closest('.ets-card');if(card)track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:'auto'});
  });
 }
}
customElements.define('envy-tester-studies',EnvyTesterStudies);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-envy-klaviyo-trigger]');
  if(!button)return;
  window._klOnsite=window._klOnsite||[];
  window._klOnsite.push(['openForm',button.getAttribute('data-envy-klaviyo-trigger')]);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

const setupEnvyMenu = (host) => {
  if (host.dataset.envyMenuReady) return;
  const panel = host.querySelector('#main-navigation');
  const toggle = host.querySelector('[data-armada-selector="navigation-toggle"]');
  const backdrop = host.querySelector('.envy-menu-backdrop');
  if (!panel || !toggle || !backdrop) return;
  host.dataset.envyMenuReady = 'true';
  const mobile = window.matchMedia('(max-width: 1023px)');
  let opened = false;
  let overflowBefore = '';
  let scrollBefore = 0;
  let bodyBefore = {};
  let htmlOverflowBefore = '';
  let inertBefore = [];
  const close = () => {
    if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    else {
      if (typeof host.closeMobileNavigation === 'function') host.closeMobileNavigation();
      document.dispatchEvent(new CustomEvent('ARMADA:NAVIGATION:MOBILE:CLOSE'));
    }
  };
  const visibleControls = () => [...panel.querySelectorAll('a[href],button,summary,input,select,[tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility === 'visible' && !el.disabled);
  const sync = () => {
    const isOpen = mobile.matches && !panel.classList.contains('invisible');
    if (isOpen === opened) return;
    opened = isOpen;
    if (opened) {
      overflowBefore = document.body.style.overflow;
      scrollBefore = window.scrollY;
      bodyBefore = {position:document.body.style.position,top:document.body.style.top,width:document.body.style.width};
      htmlOverflowBefore = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollBefore + 'px';
      document.body.style.width = '100%';
      panel.setAttribute('role','dialog');
      panel.setAttribute('aria-modal','true');
      panel.setAttribute('aria-label','Navigation');
      inertBefore = [...document.querySelectorAll('main,footer')].filter(el => !el.contains(panel)).map(el => [el,el.inert]);
      inertBefore.forEach(([el]) => el.inert = true);
      requestAnimationFrame(() => panel.querySelector('.envy-menu-close')?.focus({preventScroll:true}));
    } else {
      document.body.style.overflow = overflowBefore;
      document.body.style.position = bodyBefore.position;
      document.body.style.top = bodyBefore.top;
      document.body.style.width = bodyBefore.width;
      document.documentElement.style.overflow = htmlOverflowBefore;
      window.scrollTo({top:scrollBefore,behavior:'instant'});
      inertBefore.forEach(([el,value]) => el.inert = value);
      inertBefore = [];
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-label');
      toggle.setAttribute('aria-expanded','false');
      toggle.setAttribute('aria-label','Open navigation');
      if (mobile.matches) toggle.focus({preventScroll:true});
    }
  };
  backdrop.addEventListener('click',close);
  panel.querySelector('.envy-menu-close').addEventListener('click',close);
  host.addEventListener('keydown',event => {
    if (!opened) return;
    if (event.key === 'Escape') {event.preventDefault();close();return;}
    if (event.key !== 'Tab') return;
    const controls = visibleControls();
    const first = controls[0], last = controls[controls.length-1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {event.preventDefault();first.focus();}
  });
  const observer = new MutationObserver(sync);
  observer.observe(panel,{attributes:true,attributeFilter:['class']});
  mobile.addEventListener('change',() => {
    if (!mobile.matches && opened) close();
    sync();
  });
  sync();
};
document.querySelectorAll('header-main').forEach(setupEnvyMenu);
document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('header-main').forEach(setupEnvyMenu));


  } catch(e) { console.error(e); }
})();
})();
